import { render, staticRenderFns } from "./Listitem.vue?vue&type=template&id=5b875724&scoped=true"
import script from "./Listitem.vue?vue&type=script&lang=js"
export * from "./Listitem.vue?vue&type=script&lang=js"
import style0 from "./Listitem.vue?vue&type=style&index=0&id=5b875724&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b875724",
  null
  
)

export default component.exports